import Card from 'react-bootstrap/Card'
import React, { useRef } from 'react'
import { Col, Row } from 'react-bootstrap'
import { InputDateComponent, InputTextComponent } from 'recupero-comunes'
import { Field } from 'formik'
import Select from '../../../utils/select'
import NumberFormat from 'react-number-format'

const TotalLoss = ({ data, form, values, setFieldValue, errors }) => {
  const selects = ['mdaIndemniza', 'mdaPago', 'mdaProvision', 'mdaSalvataje']
  const refs = useRef(selects.map(() => React.createRef()))

  return (
    <Card.Body>
      <Card.Header
        className='m-2 border border-2'
        style={{backgroundColor: '#4F517A', color: 'white'}}
      >
        {form['antecliquidapt-title-seccion']}
      </Card.Header>

      <Row>
        {/* -------------------- Monto Indenizacion--- */}
        <Col md='3'>
          {data?.cbCoin?.length > 0 ? (
            <Select
              ref={refs.current[selects.indexOf('mdaIndemniza')]}
              name='mdaIndemniza'
              label={form['antecliquidapt-cmb-mdaindemniza']}
              defaultInputValue={
                data.cbCoin.find(
                  (item) => item.id === data.liquidation.codMonedaIndeminza
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbCoin ? data.cbCoin : []}
            />
          ) : null}
        </Col>
        <Col md='3' style={{fontWeight: 'bold', fontSize: '14px'}}>
          {form['antecliquidapt-input-mtoindemniza']}
          <NumberFormat
            className='form-control mt-2'
            name='mtoIndemnizacion'
            value={values.mtoIndemnizacion}
            thousandSeparator='.'
            decimalScale={2}
            decimalSeparator={values.mdaIndemniza === 30001 ? null : ','}
            onValueChange={(e) => {
              setFieldValue('mtoIndemnizacion', e.floatValue, true)
            }}
          />
          {errors?.mtoIndemnizacion ? (
            <div className='text-danger'>{errors?.mtoIndemnizacion}</div>
          ) : null}
        </Col>

        <Col md='2'>
          <Row className='mt-3'>
            <Col md='1'>
              <Field
                className=' mt-4 '
                type='checkbox'
                style={{
                  width: '25px',
                  height: '25px'
                }}
                name='indInformeLiquida'
              />
            </Col>
            <Col
              className='mt-4'
              style={{
                marginLeft: '8px'
              }}
              md='10'
            >
              {form['antecliquidadef-chk-liqasegurado-infliquida']}
            </Col>
          </Row>
        </Col>

        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          <InputDateComponent
            name='fechaInforme'
            label={form['antecliquidadef-input-fechainforme']}
          />
        </Col>

        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          <InputTextComponent
            name='factura'
            label={form['antecliquidapt-lbl-sitsalvataje']}
            value={data?.liquidation?.sitSalvataje}
            disabled
          />
        </Col>
      </Row>
      {/* -------------------- Monto Pago--- */}
      <Row className='mt-2'>
        <Col md='3'>
          {data?.cbCoin?.length > 0 ? (
            <Select
              ref={refs.current[selects.indexOf('mdaPago')]}
              name='mdaPago'
              label={form['antecliquidapp-cmb-mdapago']}
              defaultInputValue={
                data.cbCoin.find(
                  (item) => item.id === data.liquidation.codMonedaPago
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbCoin ? data.cbCoin : []}
            />
          ) : null}
        </Col>
        <Col md='3' style={{fontWeight: 'bold', fontSize: '14px'}}>
          {form['antecliquidapp-input-mtopago']}
          <NumberFormat
            className='form-control mt-2'
            name='mtoPago'
            value={values.mtoPago}
            thousandSeparator='.'
            decimalScale={2}
            decimalSeparator={values.mdaPago === 30001 ? null : ','}
            onValueChange={(e) => {
              setFieldValue('mtoPago', e.floatValue, true)
            }}
          />
          {errors?.mtoPago ? (
            <div className='text-danger'>{errors?.mtoPago}</div>
          ) : null}
        </Col>
        <Col md='2'>
          <Row className='mt-3'>
            <Col md='1'>
              <Field
                className=' mt-4 '
                type='checkbox'
                style={{
                  width: '25px',
                  height: '25px',
                  marginLeft: '8px'
                }}
                name='indFiniquito'
              />
            </Col>
            <Col
              className=' mt-4 '
              style={{
                marginLeft: '12px'
              }}
              md='6'
            >
              {form['antecliquidapt-chk-finiquito']}
            </Col>
          </Row>
        </Col>
        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          <InputDateComponent
            name='fechaPago'
            label={form['antecliquidapt-input-fechapago']}
          />
        </Col>
        <Col md='2' sm={1} style={{fontWeight: 'bold', fontSize: '14px'}}>
          <InputTextComponent
            name='factura'
            label={form['antecliquidapt-lbl-facturavta']}
            value={data?.liquidation?.indicaFacturaVenta === 1 ? 'SI' : 'NO'}
            disabled
          />
        </Col>
      </Row>
      {/* -------------------- Monto Provision--- */}
      <Row className='mt-2'>
        <Col md='3'>
          {data?.cbCoin?.length > 0 ? (
            <Select
              ref={refs.current[selects.indexOf('mdaProvision')]}
              name='mdaProvision'
              label={form['antecliquidapt-cmb-mdaprovision']}
              defaultInputValue={
                data.cbCoin.find(
                  (item) => item.id === data.liquidation.codMonedaProvision
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbCoin ? data.cbCoin : []}
            />
          ) : null}
        </Col>
        <Col md='3' style={{fontWeight: 'bold', fontSize: '14px'}}>
          {form['antecliquidapt-input-mtoprovision']}
          <NumberFormat
            className='form-control mt-2'
            name='mtoProvision'
            thousandSeparator='.'
            decimalScale={2}
            value={values.mtoProvision}
            decimalSeparator={values.mdaProvision === 30001 ? null : ','}
            onValueChange={(e) => {
              setFieldValue('mtoProvision', e.floatValue, true)
            }}
          />
          {errors?.mtoProvision ? (
            <div className='text-danger'>{errors?.mtoProvision}</div>
          ) : null}
        </Col>
        <Col md='3' >
          {data?.cbCoin?.length > 0 ? (
            <Select
              ref={refs.current[selects.indexOf('mdaSalvataje')]}
              name='mdaSalvataje'
              label={form['antecliquidapt-cmb-mdasalvataje']}
              defaultInputValue={
                data.cbCoin.find(
                  (item) => item.id === data?.liquidation?.codMonedaSalvataje
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbCoin ? data.cbCoin : []}
            />
          ) : null}
        </Col>
        <Col md='3' style={{fontWeight: 'bold', fontSize: '14px'}}>
          {form['antecliquidapt-input-mtosalvataje']}
          <NumberFormat
            className='form-control mt-2'
            name='mtoSalvataje'
            thousandSeparator='.'
            decimalScale={2}
            value={values.mtoSalvataje}
            decimalSeparator={values.mdaSalvataje === 30001 ? null : ','}
            onValueChange={(e) => {
              setFieldValue('mtoSalvataje', e.floatValue, true)
            }}
          />
          {errors?.mtoSalvataje ? (
            <div className='text-danger'>{errors?.mtoSalvataje}</div>
          ) : null}
        </Col>
      </Row>
    </Card.Body>
  )
}

export default TotalLoss
